// extracted by mini-css-extract-plugin
export default {"localDark":"custom-local-theme-module--local--dark--6127p"};